import { memo, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Stack,
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Chip,
  Typography,
  Divider,
  InputAdornment,
  IconButton,
  Tooltip,
  Alert,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const Bootic = ({ ecommerce, warehouses, onSave, loading, isEdit }) => {
  const [formData, setFormData] = useState(ecommerce);
  const [deliveryInput, setDeliveryInput] = useState("");
  const [copiedTooltip, setCopiedTooltip] = useState("");

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      configuration: {
        ...prev.configuration,
        authentication: {
          ...prev.configuration.authentication,
          [field]: value,
        },
      },
    }));
  };

  const handleWarehouseChange = (e) => {
    setFormData({ ...formData, warehouse: e.target.value });
  };

  const addDeliveryMethod = () => {
    if (!deliveryInput) return;
    const currentMethods =
      formData.configuration.options.enabled_delivery_methods || [];
    if (!currentMethods.includes(deliveryInput)) {
      setFormData((prev) => ({
        ...prev,
        configuration: {
          ...prev.configuration,
          options: {
            ...prev.configuration.options,
            enabled_delivery_methods: [...currentMethods, deliveryInput],
          },
        },
      }));
    }
    setDeliveryInput("");
  };

  const removeDeliveryMethod = (method) => {
    const currentMethods =
      formData.configuration.options.enabled_delivery_methods.filter(
        (m) => m !== method,
      );
    setFormData((prev) => ({
      ...prev,
      configuration: {
        ...prev.configuration,
        options: {
          ...prev.configuration.options,
          enabled_delivery_methods: currentMethods,
        },
      },
    }));
  };

  const handleCopy = (text, fieldName) => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      setCopiedTooltip(fieldName);
      setTimeout(() => setCopiedTooltip(""), 2000);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <form>
      <h3 style={{ marginBottom: "20px" }}>Configuración Bootic</h3>

      <Alert severity="info" sx={{ mb: 3 }}>
        Configura los tokens de acceso y luego copia las URLs de los Webhooks
        para configurarlas en tu panel de administración de Bootic.
      </Alert>

      <FormControl fullWidth sx={{ mb: 3 }}>
        <InputLabel>Bodega Asociada</InputLabel>
        <Select
          value={formData.warehouse || ""}
          label="Bodega Asociada"
          onChange={handleWarehouseChange}
        >
          {warehouses.map((w) => (
            <MenuItem key={w.id} value={w.id}>
              {w.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: "bold" }}>
        Credenciales API
      </Typography>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Token (Access Token)"
            value={formData.configuration.authentication.token || ""}
            onChange={(e) => handleChange("token", e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Refresh Token"
            value={formData.configuration.authentication.refresh_token || ""}
            onChange={(e) => handleChange("refresh_token", e.target.value)}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: "bold" }}>
        Webhooks
      </Typography>

      <Grid size={16}>
        <TextField
          id="create_order"
          name="create_order"
          label="Webhook Crear Orden"
          variant="outlined"
          value={ecommerce.configuration.create_order.url}
          sx={{ width: "100%" }}
          disabled
        />
      </Grid>
      <Grid size={16}>
        <TextField
          id="cancel_order"
          name="cancel_order"
          label="Webhook Cancelar Orden"
          variant="outlined"
          value={ecommerce.configuration.cancel_order.url}
          sx={{ width: "100%" }}
          disabled
        />
      </Grid>
      <Grid size={16}>
        <TextField
          id="update_order"
          name="update_order"
          label="Webhook Actualizar Orden"
          variant="outlined"
          value={ecommerce.configuration.update_order.url}
          sx={{ width: "100%" }}
          disabled
        />
      </Grid>

      <Box
        sx={{
          mt: 4,
          mb: 3,
          border: "1px solid #e0e0e0",
          p: 2,
          borderRadius: 2,
        }}
      >
        <InputLabel sx={{ mb: 1 }}>Métodos de Envío Habilitados</InputLabel>
        <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
          <TextField
            size="small"
            placeholder="Ej: Starken, Chilexpress..."
            value={deliveryInput}
            onChange={(e) => setDeliveryInput(e.target.value)}
            fullWidth
          />
          <Button
            variant="contained"
            onClick={addDeliveryMethod}
            disabled={!deliveryInput}
            sx={{ marginTop: "30px !important" }}
          >
            Agregar
          </Button>
        </Stack>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {formData.configuration.options.enabled_delivery_methods?.length >
          0 ? (
            formData.configuration.options.enabled_delivery_methods.map((m) => (
              <Chip
                key={m}
                label={m}
                onDelete={() => removeDeliveryMethod(m)}
                color="primary"
                variant="outlined"
              />
            ))
          ) : (
            <span style={{ color: "#999", fontSize: "0.9rem" }}>
              No hay métodos configurados
            </span>
          )}
        </Stack>
      </Box>
      <Button
        type="submit"
        variant="contained"
        fullWidth
        disabled={loading}
        size="large"
        onClick={handleSubmit}
      >
        {isEdit ? "Actualizar Integración" : "Agregar Integración"}
      </Button>
    </form>
  );
};

export default memo(Bootic);
